const root = 'subscriptionPeriodSwitcher'

export const TestId = {
  switchToPeriodButton: title => `${root}-switchTo${title}Button`,
}
